<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-show="show">
		<div class="vx-card p-6">
			<div v-if="teamReadPermission" class="vx-row">
				<div class="vx-col w-full mb-base">
					<TeamsList />
				</div>
			</div>
			<not-permission v-else></not-permission>
		</div>
	</div>
</template>

<script>
import TeamsList from "@/components/teams/TeamsList.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "TeamsListView",
	components: {
		TeamsList,
		NotPermission,
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		teamReadPermission() {
			return this.$store.getters.checkPermission("TEAMS_R");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
